import React from "react";
import { useTranslation } from "react-i18next";
import { Stack, Title, Box, Flex, Text } from "@mantine/core";
import { SegmentedScale } from "../../../components/form/SegmentedScale";

type Props = {
  form: any;
};

const ToleranciaAcosoSexual = ({ form }: Props) => {
  const { t } = useTranslation();

  const options = [
    "Es aceptable",
    "Es inadecuado, pero tolerable",
    "Es inaceptable",
    "Es acoso sexual",
  ];
  const questions = [
    "Comentarios o bromas de contenido sexual o sexista.",
    "Comentarios o bromas sobre la orientación sexual o identidad de género.",
    "Comentarios o gestos sobre la apariencia física que generan incomodidad.",
    "Contacto reiterado sin fines laborales o invitaciones insistentes a salir.",
    "Compartir contenido íntimo sin consentimiento.",
    "Contacto físico no deseado o inapropiado para el contexto laboral (rozar, masajear, besar, abrazar).",
    "Insinuar, ofrecer beneficios o amenazar condiciones laborales a cambio de acercamientos, citas o favores de índole sexual.",
  ];
  const questionIds = [
    "TOL_001AS",
    "TOL_002AS",
    "TOL_003AS",
    "TOL_004AS",
    "TOL_005AS",
    "TOL_006AS",
    "TOL_007AS",
  ];

  // Combine questions with their corresponding IDs
  const questionsWithIds = questions.map((question, index) => ({
    question,
    id: questionIds[index],
  }));

  const handleScaleClick = (questionId: string, optionValue: string) => {
    form.setFieldValue(questionId, optionValue);
  };

  return (
    <Box px="sm">
      <Stack spacing="lg">
        <Title order={3}>{t("tolerance.label")}</Title>
        {/* Leyenda */}
        <Box
          p="md"
          bg="transparent"
          style={{
            borderRadius: 8,
            border: "1px solid #e9ecef",
          }}
          mb="xl"
        >
          <Text fw={600} mb="sm" color="gray.8">
            Leyenda
          </Text>
          <Flex wrap="wrap" gap="lg" justify="space-between">
            <Text size="sm" color="gray.7">
              <strong>1</strong> = {options[0]}
            </Text>
            <Text size="sm" color="gray.7">
              <strong>2</strong> = {options[1]}
            </Text>
            <Text size="sm" color="gray.7">
              <strong>3</strong> = {options[2]}
            </Text>
            <Text size="sm" color="gray.7">
              <strong>4</strong> = {options[3]}
            </Text>
          </Flex>
        </Box>

        <Stack spacing="xl">
          {questionsWithIds.map(({ question, id }) => (
            <Box key={id}>
              <Text size="sm" mb="md" style={{ textAlign: "justify" }}>
                {question}
              </Text>
              {form.errors[id] && (
                <Text fz="xs" color="red" mb="sm">
                  *Debes seleccionar una opción.
                </Text>
              )}
              <SegmentedScale
                value={form.values[id] || ""}
                onChange={(value) => handleScaleClick(id, value)}
                segments={options}
              />
            </Box>
          ))}
        </Stack>
      </Stack>
    </Box>
  );
};

export default ToleranciaAcosoSexual;
